import { render, staticRenderFns } from "./CombinationsConfiguratorSelectorPopup.vue?vue&type=template&id=cbfc1c8e&scoped=true"
import script from "./CombinationsConfiguratorSelectorPopup.vue?vue&type=script&lang=ts"
export * from "./CombinationsConfiguratorSelectorPopup.vue?vue&type=script&lang=ts"
import style0 from "./CombinationsConfiguratorSelectorPopup.vue?vue&type=style&index=0&id=cbfc1c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfc1c8e",
  null
  
)

export default component.exports